import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Container, Grid, Typography, Link } from "@mui/material";
import { Info, Campaign, Policy, ErrorOutline, Telegram } from "@mui/icons-material";
import "./Footer.css"; // Import the CSS file

const Footer = () => {
  const navigate = useNavigate(); // Hook for navigation

  // Function to handle navigation
  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <Box component="footer" className="footer">
      <Container maxWidth="lg">
        <Grid container spacing={2} className="footer-links">
          <Grid item xs={6} sm={4} md={2} onClick={() => handleNavigation("/about")} className="clickable">
            <Info className="icon" />
            <Typography className="text">About Us</Typography>
          </Grid>
          <Grid item xs={6} sm={4} md={2} onClick={() => handleNavigation("/contact")} className="clickable">
            <Campaign className="icon" />
            <Typography className="text">Contact Us</Typography>
          </Grid>
          <Grid item xs={6} sm={4} md={2} onClick={() => handleNavigation("/privacy-policy")} className="clickable">
            <Policy className="icon" />
            <Typography className="text">Privacy Policy</Typography>
          </Grid>
          <Grid item xs={6} sm={4} md={3} onClick={() => handleNavigation("/disclaimer")} className="clickable">
            <ErrorOutline className="icon" />
            <Typography className="text">Disclaimer</Typography>
          </Grid>
        </Grid>

        {/* Join Telegram Link */}
        <Box className="telegram-link">
          <Telegram className="telegram-icon" />
          <Link 
            href="https://t.me/+p13ygJQmED5iYzE9" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="telegram-text"
          >
            Join Our Telegram
          </Link>
        </Box>

        <Typography className="powered-by">
          Powered By <span>Soumak Das</span>
        </Typography>

        <Typography className="copyright">
          Copyright © 2069 <span>All Yono Looter</span> All Rights Reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
